import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import * as layout from '@layout/index';
import { NoAuthGuard } from '@core/guard/no-auth.guard';
import { AuthGuard } from '@core/guard/auth.guard';
import { CacheRouteReuseStrategy } from './data/services/cache-route-reuse.strategy';
import { RouteReuseStrategy } from '@angular/router/';

const routes: Routes = [
  {
    path: '',
    component: layout.ContentLayoutComponent,
    canActivateChild: [],
    children: [
      {
        path: '',
        loadChildren: () =>
          import('@features/event/event.module').then(m => m.EventModule)
      }
    ]
  },
  {
    path: 'report',
    component: layout.ContentLayoutComponent,
    children: [
      {
        path: '',
        loadChildren: () =>
          import('@features/report/report.module').then(m => m.ReportModule)
      }
    ]
  },
  {
    path: 'manage/events',
    component: layout.ContentLayoutComponent,
    canActivateChild: [],
    children: [
      {
        path: '',
        loadChildren: () =>
          import('@features/manage-events/manage-events.module').then(m => m.ManageEventsModule)
      }
    ]
  },  
  {
    path: 'pagenotfound',
    loadChildren: () =>
      import('@features/page-not-found/page-not-found.module').then(m => m.PageNotFoundModule)
  },
  // Fallback when no prior routes is matched
  { path: '**', redirectTo: '/', pathMatch: 'full' }
];


@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
  providers: [AuthGuard, {provide: RouteReuseStrategy, useClass: CacheRouteReuseStrategy}]
})
export class AppRoutingModule { }
export const routingComponents = [...layout.layoutComponents];
